module.exports = __webpack_public_path__ + "img/61.59a2959d.png";